import React from 'react';
import DspxPagination from '../../../../../../../components/DspxPagination/DspxPagination';
import { useStateSelector } from '../../stateManager';
import {
  selectPage,
  selectPageSize,
  selectTotalItems,
} from '../../utils/selectors';
import { useOffsetPagination } from '../../../../../../../hooks/useOffsetPagination';
import { usePageHandler } from '../../services/page';
import styles from './index.module.scss';

const Pagination = () => {
  return (
    <div className={styles.root}>
      <Pages />
    </div>
  );
};

export default Pagination;

function Pages() {
  const total = useStateSelector(selectTotalItems);
  const pageSize = useStateSelector(selectPageSize);
  const page = useStateSelector(selectPage);

  const onChange = usePageHandler();

  const { setPage } = useOffsetPagination({
    total,
    pageSize,
    resetToFirstPage: true,
    controller: { value: page, onChange },
  });

  return (
    <DspxPagination
      current={page >= 1 && page <= Math.ceil(total / pageSize) ? page : 1}
      total={total}
      pageSize={pageSize}
      showQuickJumper
      quickJumperToStart
      hideOnSinglePage
      onChange={setPage}
      className={styles.pages}
    />
  );
}
